import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4935792c")

_pushScopeId("data-v-4935792c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Presenze")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "timer_clock" }
const _hoisted_5 = { class: "today_date" }
const _hoisted_6 = {
  key: 0,
  class: "btn_presenze_container ion-padding-horizontal"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "Timbra entrata", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Timbra uscita", -1)
const _hoisted_9 = {
  key: 1,
  class: "btn_presenza_container ion-padding-horizontal"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Inserisci presenza", -1)
const _hoisted_11 = {
  key: 2,
  class: "ion-padding-horizontal ion-margin-bottom"
}
const _hoisted_12 = { class: "ion-padding-horizontal ion-margin-bottom" }
const _hoisted_13 = {
  key: 3,
  class: "no_presenze_container"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "no_presenze" }, "Nessuna presenza inserita", -1)
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { class: "container_presenze" }
const _hoisted_17 = { class: "presenza_info" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "orari" }
const _hoisted_20 = {
  key: 0,
  class: "straordinario"
}
const _hoisted_21 = {
  key: 0,
  class: "status"
}
const _hoisted_22 = {
  key: 0,
  class: "modal_straordinario"
}
const _hoisted_23 = { class: "input_container" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "title_qr" }, "Inquadra il codice QR per timbrare", -1)
const _hoisted_25 = { class: "qr_code" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "frame" }, null, -1)
const _hoisted_27 = { class: "confirmation_text" }
const _hoisted_28 = {
  key: 0,
  class: "modal_straordinario"
}
const _hoisted_29 = { class: "input_container" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Personalizza lo straordinario effettuato", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_qr_stream = _resolveComponent("qr-stream")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start",
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadTimbrature()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        ionScroll: "scrollFunction($event)"
      }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, _toDisplayString($setup.time), 1),
                _createVNode("div", _hoisted_5, _toDisplayString($setup.todayDate), 1),
                (_ctx.$showButtonsTimbrature === 'true')
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("button", {
                        class: "btn_timbratura",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleTimbraEntrata && $setup.handleTimbraEntrata(...args))),
                        disabled: $setup.entrataTimbrata
                      }, [
                        _createVNode(_component_ion_icon, {
                          icon: $setup.arrowForward,
                          slot: "end"
                        }, null, 8, ["icon"]),
                        _hoisted_7
                      ], 8, ["disabled"]),
                      _createVNode("button", {
                        class: "btn_timbratura",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleTimbraUscita && $setup.handleTimbraUscita(...args))),
                        disabled: $setup.uscitaTimbrata
                      }, [
                        _createVNode(_component_ion_icon, {
                          icon: $setup.arrowBack,
                          slot: "end"
                        }, null, 8, ["icon"]),
                        _hoisted_8
                      ], 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$showButtonPresenza === 'true')
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode("button", {
                        class: "btn_presenza",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.createPresenza && $setup.createPresenza(...args)))
                      }, [
                        _hoisted_10
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$showQrCodeButton === 'true')
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("div", {
                        class: "btn_reperibilita",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openQrCode()))
                      }, " Timbra con Codice QR ")
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", {
                    class: "btn_reperibilita",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openReperibilita()))
                  }, " Dichiara reperibilità ")
                ]),
                (!$setup.presenze.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.presenze, (timbratura) => {
                          return (_openBlock(), _createBlock("div", {
                            key: timbratura.presenze_id,
                            class: "presenza"
                          }, [
                            _createVNode("div", _hoisted_17, [
                              _createVNode("div", _hoisted_18, _toDisplayString($setup.dateFormat(timbratura.presenze_data_inizio)) + " " + _toDisplayString($setup.printCustomer(timbratura)), 1),
                              _createVNode("div", _hoisted_19, " Ingresso: " + _toDisplayString(timbratura.presenze_ora_inizio) + " - Uscita: " + _toDisplayString(timbratura.presenze_ora_fine || "-"), 1),
                              (timbratura.presenze_straordinario > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_20, " Straordinario: " + _toDisplayString(parseFloat(timbratura.presenze_straordinario).toFixed(2)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.$showStraordinarioButton === 'true')
                              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                  _createVNode("span", {
                                    class: "straordinario_button",
                                    onClick: ($event: any) => ($setup.apriStraordinario(timbratura))
                                  }, " Straordinario ", 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])),
                _createVNode(_Transition, { name: "fade-transition" }, {
                  default: _withId(() => [
                    ($setup.showQrCode)
                      ? (_openBlock(), _createBlock("div", _hoisted_22, [
                          _createVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createVNode("div", _hoisted_25, [
                              _createVNode(_component_qr_stream, {
                                onDecode: $setup.onDecode,
                                class: "mb"
                              }, {
                                default: _withId(() => [
                                  _hoisted_26
                                ]),
                                _: 1
                              }, 8, ["onDecode"])
                            ]),
                            _createVNode("div", _hoisted_27, _toDisplayString($setup.confirmationText), 1),
                            _createVNode("button", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.handleQrCodeTimbratura())),
                              class: "btn_salva_straordinario",
                              disabled: $setup.disabledQrCodeButton
                            }, "Salva", 8, ["disabled"]),
                            _createVNode("button", {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.chiudiQrCode())),
                              class: "btn_chiudi_straordinario"
                            }, "Chiudi")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "fade-transition" }, {
                  default: _withId(() => [
                    ($setup.showStraordinario)
                      ? (_openBlock(), _createBlock("div", _hoisted_28, [
                          _createVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.selectedPresenza.presenze_straordinario,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ($setup.selectedPresenza.presenze_straordinario = $event)),
                              type: "number"
                            }, null, 8, ["modelValue"]),
                            _createVNode("div", {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.salvaStraordinario())),
                              class: "btn_salva_straordinario"
                            }, "Salva"),
                            _createVNode("div", {
                              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.chiudiStraordinario())),
                              class: "btn_chiudi_straordinario"
                            }, "Chiudi")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})